module.exports = __webpack_public_path__ + "closedhand.a8c874b93b3d848f39a7.cur";


//////////////////
// WEBPACK FOOTER
// C:/Users/TerrellDavis/Documents/GitHub/AVL/realavl/realavl/src/assets/js/revolution/css/closedhand.cur
// module id = ../../../../../src/assets/js/revolution/css/closedhand.cur
// module chunks = styles